const entitlementEnumerators = {
  source: ['Apple', 'Google', 'Stripe', 'Company', 'Roku'],
  renewalPeriod: ['Monthly', 'Annually'],
};

export default entitlementEnumerators;
